import React, { useEffect, useState } from "react";
import { useForm, useFieldArray, Controller, useWatch } from "react-hook-form";
import axios from 'axios';
import { headers } from '../utils/common';
import { Modal, Button } from 'react-bootstrap';
import * as axiosInstance from '../utils/axiosinstace';
import { useTranslation } from 'react-i18next';
const AddIntegrator = (props) => {
  const { t } = useTranslation(['farm', 'common']);
    const [headersobj] = useState(headers());
    const { register, handleSubmit, reset, watch, formState: { errors }, setValue} = useForm({
        mode: 'onChange'
    });
    const [showResults, setShowResults] = useState(false)
    const [resultMessage, setResultMessage] = useState({});
    const [title, setTitle] = useState('Add')
    const onSubmit = async(data, e) => {

        e.preventDefault();
        data.action = props.rowObj.actionType=='edit'?'edit': 'new';
        data.id= props.rowObj.id!==undefined?props.rowObj.id:'';
        try {
            const response = await axiosInstance.addIntegrator(data)
            console.log(response.message);
            setShowResults(true);
            setResultMessage({
                error: false, message: response.message
            });
            //reset();
        } catch (err) {
            console.log(err)
                setShowResults(true)
                setResultMessage({
                    error: true, message: err.response.data.message
                });
        }
    }
    const handleChange = () => {
        props.onChange(false);
        setShowResults(false);
    }
    useEffect(()=>{
        console.log(props.rowObj);
        if(props.rowObj.actionType == 'edit') {
            setValue('name', props.rowObj.name);
            setValue('status', props.rowObj.status);   
        }
    },[])
    return (
        <div className="updateDevice">

            <Modal show={props.show}>
                <Modal.Header>
                    <Modal.Title>
                        {t('farm:integrator.addIntegrator')}
                    </Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor>{t('farm:integrator.integratorName')}</label>
                                <input type="text" className="form-control" placeholder={t('farm:integrator.enterIntegratorName')}
                                    name="name"
                                    {...register("name", {
                                        required: t('forms:enter.integratorName'),
                                        minLength: { value: 3, message: t('common:validation.nameTooShort') },
                                        maxLength: { value: 100, message: t('common:validation.nameTooLong') }
                                    })}
                                />
                                {errors.name && <span className="err-msg">{errors.name.message}</span>}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor>{t('common:select.status')}</label>
                                <select class="form-control" name="status"
                                    {...register('status', {
                                        required: t('forms:select.status')
                                    })}
                                >
                                    <option value='Active'>{t('common:state.active')}</option>
                                    <option value='Inactive'>{t('common:state.inactive')}</option>
                                </select>
                                {errors.status && <span className="err-msg">{errors.status.message}</span>}
                            </div>
                        </div>
                        {showResults ? <Results key={Math.random()} message={resultMessage.message} error={resultMessage.error} /> : null}
                    </Modal.Body>
                    <Modal.Footer>

                        <input type="submit" value="Submit" className="btn btn-primary" />
                        {/* <button type="submit" className="btn btn-primary">{t('common:actions.submit')}</button> */}
                        <Button variant="secondary" onClick={handleChange}>{t('common:actions.close')}</Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    )
}
const Results = (props) => {
    let error, classes;
    if (props.error === false) {
        error = 'Success';
        classes = 'alert alert-success alert-dismissible fade show'
    } else {
        error = 'Error!';
        classes = 'alert alert-danger alert-dismissible fade show'
    }
    return (
        <div className="results">
            <div className={classes}>
                <strong>{error}</strong> {props.message}
                <button type="button" class="close" data-dismiss="alert">&times;</button>
            </div>
        </div>
    );
}
export default AddIntegrator;
